import { Injectable } from "@angular/core";
import { MCFormisForm, MCEnvironmentsService, MCSectionSchema, MCStore } from "@maslul/common-services";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { Observable } from "rxjs";

export class AttachmentsStoreData {

    formisForm: MCFormisForm | undefined;
    formisFormModel: any;
    formisFormFields: Array<FormlyFieldConfig> | undefined;
    fieldsSchema: Array<MCSectionSchema> | undefined;

}
const ATTACHMENTS_DETAILS: AttachmentsStoreData =
{
    formisForm: undefined,
    formisFormModel: {},
    formisFormFields: undefined,
    fieldsSchema: undefined

}

@Injectable({
    providedIn: 'root',
})
export class AttachmentsStore extends MCStore<AttachmentsStoreData> {

    constructor(protected override environmentsService: MCEnvironmentsService) {
        super('', ATTACHMENTS_DETAILS, environmentsService);
    }


    getFormisForm(): Observable<MCFormisForm | undefined> {
        return this.select(s => s.formisForm);
    }

    setFormisForm(formisForm: MCFormisForm) {
        this.updateState('[Attachments MCStore Service] set formisForm', { formisForm })
    }

    getFormisFormModel(): Observable<any> {
        return this.select(s => s.formisFormModel);
    }

    setFormisFormModel(formisFormModel: any) {
        this.updateState('[Attachments Details MCStore Service] set formisForm model', { formisFormModel: formisFormModel })
    }

    getFormisFormFields(): Observable<Array<FormlyFieldConfig> | undefined> {
        return this.select(s => s.formisFormFields);
    }

    setFormisFormFields(formisFormFields: Array<FormlyFieldConfig>) {
        this.updateState('[Attachments Details MCStore Service] set formisForm Fields', { formisFormFields: formisFormFields })
    }
    getFieldsSchema(): Observable<Array<MCSectionSchema> | undefined> {
        return this.select(s => s.fieldsSchema);
    }

    setFieldsSchema(fieldsSchema: Array<MCSectionSchema>) {
        this.updateState('[Attachments Details MCStore Service] set fieldsSchema', { fieldsSchema: fieldsSchema })
    }
}